// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"131":"44bcf6f9","147":"766e3a25","266":"e0e43588","369":"d7f66852","489":"fbace7c6","634":"ce082f17","656":"b8b2a549","819":"78d7b649","933":"f6b8b5af"}[chunkId] + ".chunk.js";
};